import {ref} from "vue";
import {router} from "@inertiajs/vue3";

const defaultModal = {
    'title': 'Demande de confirmation',
    'content': 'Êtes-vous sûr de vouloir effectuer cette action ?',
    'leftButton': 'Annuler',
    'rightButton': 'Valider',
    'colorLeftButton': 'bg-red-600 hover:bg-red-500 focus:bg-red-500',
    'colorRightButton': 'bg-green-600 hover:bg-green-500 focus:bg-green-500',
}

export const modalConfirmTitle = ref<string>();
export const modalConfirmContent = ref<string>();
export const modalConfirmLeftButton = ref<string>();
export const modalConfirmRightButton = ref<string>();
export const modalConfirmShow = ref(false);
export const DsModalConfirmResponse = ref<boolean | null>(null);
export const modalConfirmColorLeftButton = ref<string>();
export const modalConfirmColorRightButton = ref<string>();
export const modalTimeBeforeValidate = ref<number>(0);

let modalResolve: ((value: boolean) => void) | null = null;
let removeNavigationListener: (() => void) | null = null;

function cancelOnNavigation() {
    modalConfirmValidate(false);
}

export async function DsAlertConfirm(newTitle?: string, newContent?: string, newLeftButton?: string, newRightButton?: string,
                                     colorLeftButton?: string, colorRightButton?: string,time_before_validate : number = 0) {
    if (modalResolve) {
        modalConfirmValidate(false);
    }
    modalConfirmTitle.value = newTitle ?? defaultModal.title
    modalConfirmContent.value = newContent ?? defaultModal.content
    modalConfirmLeftButton.value = newLeftButton ?? defaultModal.leftButton
    modalConfirmRightButton.value = newRightButton ?? defaultModal.rightButton
    modalConfirmColorLeftButton.value = colorLeftButton ?? defaultModal.colorLeftButton
    modalConfirmColorRightButton.value = colorRightButton ?? defaultModal.colorRightButton
    modalConfirmColorRightButton.value = colorRightButton ?? defaultModal.colorRightButton
    modalTimeBeforeValidate.value = time_before_validate ?? 0

    modalConfirmShow.value = true;

    return new Promise<boolean>((resolve) => {
        modalResolve = resolve;
        window.addEventListener('popstate', cancelOnNavigation);
        removeNavigationListener = router.on('navigate', cancelOnNavigation);
    });
}

export function modalConfirmValidate(response: boolean) {
    const resolve = modalResolve;
    modalResolve = null;
    window.removeEventListener('popstate', cancelOnNavigation);
    removeNavigationListener?.();
    removeNavigationListener = null;
    DsModalConfirmResponse.value = response
    modalConfirmShow.value = false
    resolve?.(response);
}

export function modalConfirmResetState() {
    if (modalConfirmShow.value) return;
    modalConfirmTitle.value = defaultModal.title
    modalConfirmContent.value = defaultModal.content
    modalConfirmLeftButton.value = defaultModal.leftButton
    modalConfirmRightButton.value = defaultModal.rightButton
    modalResolve = null;
}
